import { useCallback, useEffect, useRef, useState } from 'react';

type IntersectionProps = {
	root?: null | Element;
	rootMargin?: string;
	threshold?: number;
	callback?: () => void;
};

const useIntersection = (props: IntersectionProps) => {
	const { root = null, rootMargin, threshold = 1.0, callback = () => {} } = props;
	const [intesecting, setIntersecting] = useState<boolean>(false);
	const [target, setTarget] = useState<Element | null>(null);
	const callbackRef = useRef(callback);
	const setRef = useCallback((node: Element | null) => setTarget(node), []);

	useEffect(() => {
		callbackRef.current = callback;
	}, [callback]);

	useEffect(() => {
		if (!target) return;
		const observer = new IntersectionObserver(
			([entry]) => {
				const intersect = entry.isIntersecting;
				setIntersecting(intersect);
				if (intersect) {
					callbackRef.current();
				}
			},
			{
				root,
				rootMargin,
				threshold,
			}
		);
		observer.observe(target);
		return () => {
			observer.disconnect();
		};
	}, [root, rootMargin, target, threshold]);

	return [setRef, intesecting];
};

export default useIntersection;
